import { render } from "./SeatFare.vue?vue&type=template&id=2f92936f&scoped=true"
import script from "./SeatFare.vue?vue&type=script&lang=js"
export * from "./SeatFare.vue?vue&type=script&lang=js"

import "./SeatFare.vue?vue&type=style&index=0&id=2f92936f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f92936f"]])

export default __exports__